import { cx } from '@/utils/cx'
import { Button, DocumentCheckbox } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import PrivacyPolicy from '@assets/privacy_policy.pdf'
import PrivacyPolicyDe from '@assets/privacy_policy_de.pdf'
import { StoreContext } from '@store/Root.store'
import { actionReport } from '@methods/actionReport'
import { IkanoOpenbankingInfoGraph } from './icons/IkanoOpenbankingInfoGraph'
import { CheckedEvent } from '@/types/generic'

export const MicropaymentInfoIkanoOpenBankingPage = observer(() => {
  const store = useContext(StoreContext)
  const { context } = store.ScenarioState

  const { language } = store.TranslationsState
  const {
    micropaymentInfoOpenBankingPage: trans,
    klarnaPrivacyPolicyPage: policyPage,
    generalConditionsPage: generalConditionsTrans,
  } = store.TranslationsState.translationsNew

  const [signed, setSigned] = useState(false)
  const [openBanking, setOpenBanking] = useState(false)

  const { isMobile } = store.AppState

  const handleOpenBanking = ({ checked: value }: CheckedEvent) => {
    if (value) {
      actionReport({
        type: 'event.onboarding-web.consent.CONSENT_CHECKED',
        payload: { documentType: 'OPEN_BANKING', isRequired: true },
      })
    } else {
      actionReport({
        type: 'event.onboarding-web.consent.CONSENT_UNCHECKED',
        payload: { documentType: 'OPEN_BANKING', isRequired: true },
      })
    }

    setOpenBanking(value)
  }

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  useEffect(() => {
    if (context?.termsAndConditionsPresent) {
      store.ScenarioState.nextPage()
    }
  }, [])

  useEffect(() => {
    if (openBanking === true) {
      setSigned(true)
      actionReport({
        type: 'event.onboarding-web.consent.CONSENT_ACCEPTED',
        payload: {},
      })
    } else {
      setSigned(false)
    }
  }, [openBanking])

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40')}>
      <>
        <div className="ikano__micropayment-info-graph">
          <IkanoOpenbankingInfoGraph />
        </div>

        {trans.content.split('\n').map((item, i) => (
          <div className="generic__paragraph m-0-0-24" key={i}>
            {item}
          </div>
        ))}

        {/* Open Banking */}
        <DocumentCheckbox
          inputName="iddata-checkbox"
          description={policyPage.consent}
          externalUrl={language === 'de' ? PrivacyPolicyDe : PrivacyPolicy}
          handleDecision={handleOpenBanking}
          value={openBanking}
          goToDocumentLabel={generalConditionsTrans.goToDocument}
        />

        <div className="layout__content-container-bottom-fixed">
          {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}
          <Button onClick={() => handleProceed()} disabled={!signed}>
            <span className="generic__button-text">{trans.proceed}</span>
          </Button>
        </div>

        <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
      </>
    </div>
  )
})
